import { db } from '../utils/firebase';

export const getIntroduction = async () => {
  const introduction = db.collection("common_skills").doc("introduction");
  const doc = await introduction.get();
  const { content } = doc.data();

  return { content };
}

export const getSkills = async () => {
    const skills = db.collection("common_skills").doc("skills");
    // get childrens
    const children = [];
    const querySnapshot = await skills.collection("children").get();
    querySnapshot.forEach(doc => {
      const { subtitle, content, order } = doc.data();
      children.push({ subtitle, content, order });
    });
    children.sort((a, b) => a.order - b.order)
    return { skills: children };
  }

  